import { SvgIcon } from '@material-ui/core';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0.167 16 10.667">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M10.6.5h-5a5 5 0 1 0 0 10h5a5 5 0 1 0 0-10zm-8.333 5A3.331 3.331 0 0 1 5.6 2.167 3.331 3.331 0 0 1 8.933 5.5 3.332 3.332 0 0 1 5.6 8.833 3.331 3.331 0 0 1 2.267 5.5zM10.6 8.833H9.326a4.998 4.998 0 0 0 0-6.666H10.6A3.332 3.332 0 0 1 13.933 5.5 3.332 3.332 0 0 1 10.6 8.833z"
    />
  </SvgIcon>
);

export default Icon;
